<div class="d-flex ion-align-items-center ion-justify-content-between py-sm"
     [ngClass]="shoBorderBottom ? 'border-bottom ': ''">
    <div>
        <div>
            <div class="  font-weight-bold">{{label}}</div>
            <div class=" ">{{text}}</div>
        </div>
    </div>
    <div class="d-flex ion-justify-content-end">
        <ng-content #btnTmpl select="[rowBtn]"></ng-content>
    </div>
</div>
